// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/20250430044934/js/" + chunkId + "." + {"453":"f3487ca5","766":"4fad1aad","941":"cc8db183","951":"e3a4c2b9"}[chunkId] + ".chunk.js";
};